import { MessageDialog } from '@components/UI-Components/MessageDialog'
import { OrderType } from '@modules/common/models/enums/OrderManagement'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import CreateCopyTemplatePopup from '@modules/order/components/CellTemplates/Quantities/DraftUnSizedQuantity/CreateCopyTemplatePopup/CreateCopyTemplatePopup'
import TemplateListPopup from '@modules/order/components/CellTemplates/Quantities/DraftUnSizedQuantity/TemplateListPopup/TemplateListPopup'

interface IEnhancedProductQuantityColumnPopups {
  showSaveCopyTemplate: boolean
  noBookedDoors: boolean
  openDialog: any
  showCopiedTemplates: boolean
  copiedTemplateQuantities: any
  orderType: string
  dialogTitle?: string
  dialogMessage?: string
  setShowSaveCopyTemplate: (value: boolean) => void
  handleDialogClose: () => void
  setShowCopiedTemplates: (value: boolean) => void
  deleteCopiedTemplate: (value: any) => void
  onSelectTemplateItem: (a, b) => void
  onSaveTemplate: (a) => void
}

const EnhancedProductQuantityColumnPopups: FC<IEnhancedProductQuantityColumnPopups> = ({
  showSaveCopyTemplate,
  noBookedDoors,
  orderType,
  openDialog,
  showCopiedTemplates,
  copiedTemplateQuantities,
  dialogTitle,
  dialogMessage,
  setShowSaveCopyTemplate,
  handleDialogClose,
  setShowCopiedTemplates,
  deleteCopiedTemplate,
  onSelectTemplateItem,
  onSaveTemplate
}) =>
  useObserver(function useHook() {
    const { t } = useTranslation()

    return (
      <>
        {openDialog ? (
          <MessageDialog
            open={openDialog}
            title={dialogTitle ?? t('common.label.notAllowed', 'Not Allowed')}
            message={dialogMessage}
            handleClose={handleDialogClose}
            closeButtonTitle={t('bb.common.label.ok', 'Ok')}
          />
        ) : null}
        {showSaveCopyTemplate ? (
          <CreateCopyTemplatePopup
            open={showSaveCopyTemplate}
            onClose={() => {
              setShowSaveCopyTemplate(false)
            }}
            onSave={onSaveTemplate}
          />
        ) : null}
        {showCopiedTemplates ? (
          <TemplateListPopup
            onSelect={onSelectTemplateItem}
            options={copiedTemplateQuantities}
            recentOption={{}}
            open={showCopiedTemplates}
            onDelete={deleteCopiedTemplate}
            onClose={() => {
              setShowCopiedTemplates(false)
            }}
            disableDoorBooking={orderType === OrderType.Door}
            hasAllUnbookedDoors={noBookedDoors}
          />
        ) : null}
      </>
    )
  })

export default EnhancedProductQuantityColumnPopups
